import { useEffect } from 'react';

/**
 * Writes the visible viewport height to --app-viewport-height on :root.
 * Uses visualViewport so full-height panels fit below mobile browser chrome (Android/iOS).
 */
export const useViewportHeight = (enabled = true) => {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        const update = () => {
            const height = window.visualViewport?.height ?? window.innerHeight;
            document.documentElement.style.setProperty('--app-viewport-height', `${height}px`);
        };

        update();

        window.visualViewport?.addEventListener('resize', update);
        window.visualViewport?.addEventListener('scroll', update);
        window.addEventListener('resize', update);
        window.addEventListener('orientationchange', update);

        return () => {
            window.visualViewport?.removeEventListener('resize', update);
            window.visualViewport?.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
            window.removeEventListener('orientationchange', update);
            document.documentElement.style.removeProperty('--app-viewport-height');
        };
    }, [enabled]);
};
